<template>
  <feather-icon icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="getBookLists()"/>
</template>

<script>
  import 'jspdf-autotable'
  import jsPDF from "jspdf";
  import {font} from "./assets/THSarabunNew-normal";
  import {font_bold} from "./assets/THSarabunNew-bold";
  import moment from "moment";
  import moduleBookList from "@/store/booklist/moduleBookList.js";
  import {formatNumber2Digit, formatNumber} from "./assets/utils";
  export default {
    props: ['billConfig', 'area', 'org', 'status'],
    components: {
      jsPDF,
    },
    name: "P17PrapaReport",
    data() {
      return {
        thmonth: ['', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม',
          'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน',
          'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      }
    },
    methods: {
      currentThaiDate() {
        const date = moment().format('DD/MM/YYYY');
        const dateSplit = date.split('/');
        const year = parseInt(dateSplit[2]) + 543;
        return dateSplit[0] + '/' + dateSplit[1] + '/' + year;
      },
      warningDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          title: `คำเตือน`,
          text: 'ไม่มีรายชื่อในรายงาน ป.17 ค่าขยะ',
          acceptText: 'ปิด'
        })
      },
      async getBookLists() {
        this.$vs.loading();
        let payload = {};
        if (this.status !== undefined) {
          payload.B10 = this.status;
        }
        await this.$store.dispatch("bookLists/fetchDebtByAreaDataListItems", payload).then((res) => {
          if (res.status === 200 && res.data.length !== 0) {
            const booklists = res.data;
            this.generatePDF(booklists);
            this.$vs.loading.close();
          } else {
            this.warningDialog();
            this.$vs.loading.close();
          }
        }).catch((error) => {
          this.warningDialog();
          this.$vs.loading.close();
        });
      },
      formatDate(text) {
        try {
          const date = moment(text).format('DD/MM/YYYY');
          const dateSplit = date.split('/');
          const year = parseInt(dateSplit[2]) + 543;
          return dateSplit[0] + '/' + dateSplit[1] + '/' + year;
        }catch (e) {
          return text
        }
      },
      generatePDF(bookLists) {
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: [279.4, 210]
        });
        const org = this.org;
        const district = org.Org01;
        const address = org.Org03;
        const month = bookLists[0].CB04;
        const id_bill = bookLists[0].B01;
        const date = this.currentThaiDate()
        const area = this.area;
        let sumUnit = 0;
        let sumPrapa = 0;
        let sumService = 0;
        let sumVat = 0;
        let sumPrapaVat = 0;
        let sumBA = 0;
        let sum = 0;
        let array = [];
        let sum_payment_footer = 0;
        let index = 0;
        for (let i = 0; i < bookLists.length; i++) {
          const item = bookLists[i];
          item.list.forEach(function (data) {
            index += 1;
            let BA14 = 0;
            let BA15 = 0;
            let sumBA = 0;
            if (data.BA14 !== undefined && data.BA14 !== null && data.BA14 !== '' && data.BA14 !== 'NaN') {
              BA14 = parseFloat(data.BA14);
              sumService += parseFloat(data.BA14);
              sumBA += parseFloat(data.BA14);
            }
            if (data.BA15 !== undefined && data.BA15 !== null && data.BA15 !== '' && data.BA15 !== 'NaN') {
              BA15 = parseFloat(data.BA15);
              sumBA += parseFloat(data.BA15);
              sumVat += parseFloat(data.BA15);
              sumPrapaVat += parseFloat(data.BA14) + parseFloat(data.BA15)
            }
            if (data.B21 !== undefined && data.B21 !== null && data.B21 !== '' && data.B21 !== 'NaN') {
              sumUnit += parseInt(data.B21);
            }

            sum += sumBA;
            let sum_payment = 0;
            if (data.B10 === '1') {
              sum_payment = sumBA;
            }
            sum_payment_footer += sum_payment;
            let B22 = ''
            if(data.B22 !== '')
              B22 = data.B22
            array.push([
              index,
              data.B03,
              item.member_name,
              data.CB04,
              B22,
              formatNumber2Digit(BA14),
              formatNumber2Digit(BA15),
              formatNumber2Digit(sumBA)
            ]);
          })
        }
        array.push([
          'รวมทั้งสิ้น',
          '',
          '',
          '',
          '',
          formatNumber2Digit(sumService),
          formatNumber2Digit(sumVat),
          formatNumber2Digit(sum),
        ]);
        array.push([
          'ค่ากำจัดขยะฯ+ค่าขยะ',
          '',
          '',
          '',
          '',
          '',
          formatNumber(sumPrapaVat),
        ]);
        var totalPagesExp = '{total_pages_count_string}';
        doc.addFileToVFS('THSarabunNew-normal.ttf', font);
        doc.addFileToVFS('THSarabunNew-bold.ttf', font_bold);
        doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
        doc.addFont('THSarabunNew-bold.ttf', 'THSarabunNew', 'bold');
        doc.autoTable({
          showHead: 'everyPage',
          showFoot: 'everyPage',
          styles: {font: 'THSarabunNew', fontSize: 11, textColor: 0},
          margin: {left: 16, top: 35, right: 5},
          theme: 'plain',
          head: [
            [
              'ลำดับที่',
              'รหัส',
              'ชื่อสกุลสมาชิกผู้ชำระค่าขยะ',
              'ประจำเดือน',
              'เลขที่ใบแจ้งหนี้',
              'ค่ากำจัดขยะฯ',
              'ค่าขยะ',
              'รวมเงิน'
            ]
          ],
          body: array,
          didDrawPage: function (data) {
            doc.setFont('THSarabunNew', 'bold');
            doc.setFontSize(16);
            doc.text(district, doc.internal.pageSize.getWidth() / 2, 10, {align: 'center'});
            doc.text(address, doc.internal.pageSize.getWidth() / 2, 16, {align: 'center'});
            doc.setFontSize(14);
            doc.text('บัญชีรายตัวลูกหนี้ ประเภทค่าขยะ', doc.internal.pageSize.getWidth() / 2, 25, {align: 'center'});
            doc.setFont('THSarabunNew', 'normal');
            var str = 'Page ' + doc.internal.getNumberOfPages();
            if (typeof doc.putTotalPages === 'function') {
              str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(12);
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text('วันที่พิมพ์ ' + date, 8, pageHeight - 8,);
          },
        });
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp);
        }
        doc.save(`kaya_all_debt_` + moment().format('DD-MM-YYYY') + '.pdf');
      }
    },
    created() {
      if (!moduleBookList.isRegistered) {
        this.$store.registerModule('bookLists', moduleBookList);
        moduleBookList.isRegistered = true;
      }
    }
  }
</script>
